import $ from 'jquery';

/**
 * AI Feature Help Content
 * Contains descriptions, usage info, and examples for each AI feature
 */
export const AI_FEATURE_HELP_CONTENT = {
  // Background features
  removebg: {
    title: 'Rimuovi Sfondo',
    highlightText: '🎯 Isola il soggetto con precisione professionale',
    description:
      'Rimuove automaticamente lo sfondo dalle foto per creare ritratti commemorativi puliti e professionali. Ideale per applicare sfumature o sfondi dietro al ritratto da inserire in necrologi, manifesti funebri e ricordini.',
    whenToUse:
      'Foto per manifesti funebri • Ritratti per ricordini • Immagini per necrologi • Foto tessera per documenti commemorativi • Composizioni fotografiche per cerimonie',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-bg-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-bg-after.png',
    faq: [
      {
        question: 'Quando devo usare la funzione Rimuovi Sfondo?',
        answer:
          'Ti consigliamo di usarla per ultima, dopo aver applicato tutte le altre funzioni (come miglioramento o espansione), perché crea zone trasparenti. Se usata prima, le altre funzioni potrebbero non funzionare bene o creare aree nere.',
      },
      {
        question:
          'Voglio aggiungere una sfumatura o un nuovo sfondo: va bene usare Rimuovi Sfondo?',
        answer:
          'Sì, Rimuovi Sfondo è la scelta migliore se vuoi applicare una sfumatura o inserire un nuovo sfondo. In questo modo il soggetto viene isolato e si adatta perfettamente alla grafica.',
      },
    ],
  },
  blurbg: {
    title: 'Sfoca Sfondo',
    highlightText: '📸 Metti in risalto il defunto con delicatezza',
    description:
      'Applica una sfocatura professionale allo sfondo per evidenziare rispettosamente il soggetto. Perfetto per creare ritratti commemorativi eleganti e dignitosi.',
    whenToUse:
      'Ritratti per manifesti funebri • Foto per ricordini commemorativi • Immagini per libri firma • Ritratti per cappelle ardenti • Foto per servizi online di commemorazione',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/blur-bg-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/blur-bg-after.jpg',
    faq: [
      {
        question: 'Posso scegliere quanto sfocare lo sfondo?',
        answer:
          "Sì, puoi scegliere tra 5 livelli di sfocatura, da leggera a più intensa. In questo modo puoi adattare l'effetto in base al tipo di foto e al risultato che desideri ottenere.",
      },
      {
        question:
          'Quando conviene usare Sfoca Sfondo rispetto a Rimuovi Sfondo?',
        answer:
          'Sfoca Sfondo è utile quando vuoi mantenere lo sfondo ma renderlo meno visibile, dando risalto al soggetto. È ideale per creare un effetto elegante e rispettoso. Rimuovi Sfondo invece elimina completamente lo sfondo: va usata solo se vuoi inserire un nuovo sfondo o lasciare trasparenza.',
      },
    ],
  },
  dissolvenza: {
    title: 'Dissolvenza',
    highlightText: '🌫️ Effetto sfumatura ovale delicato',
    description:
      'Crea una dissolvenza ovale morbida che sfuma gradualmente verso il bianco, mantenendo il soggetto centrale nitido. Ideale per ritratti commemorativi che richiedono un effetto vignettatura elegante e rispettoso.',
    whenToUse:
      'Ritratti commemorativi per manifesti funebri • Foto per santini e ricordini • Immagini per lapidi digitali • Ritratti per cerimonie commemorative • Foto per libri di condoglianze',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/dissolvenza-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/dissolvenza-after.jpg',
    faq: [
      {
        question: "Che differenza c'è tra Dissolvenza e Sfoca Sfondo?",
        answer:
          'La Dissolvenza crea una sfumatura ovale che gradualmente sfuma verso il bianco ai bordi, mantenendo il centro nitido. È perfetta per creare un effetto vignettatura delicato. Sfoca Sfondo invece mantiene tutto il soggetto nitido e sfoca solo lo sfondo circostante.',
      },
      {
        question: 'È adatta per tutti i tipi di foto?',
        answer:
          "Funziona meglio con ritratti centrati dove il soggetto principale è al centro dell'immagine. Per un risultato ottimale, andrebbe usata con un sfondo chiaro o bianco uniforme.",
      },
    ],
  },
  expand: {
    title: 'Espandi Scena',
    highlightText: '📸 Ricrea le parti mancanti della foto',
    description:
      'Grazie all’AI, questa funzione ti permette di ricostruire le aree mancanti attorno al soggetto, completando l’inquadratura originale o generando nuove porzioni dell’immagine in modo armonioso. Utile non solo per foto tagliate o danneggiate, ma anche quando manca spazio attorno al soggetto o quando vuoi rimuovere una parte poco adatta e ricostruirla con continuità.',

    whenToUse:
      'Foto ritagliate o tagliate male • Immagini rovinate o incomplete • Composizioni grafiche con soggetti centrali • Cornici e manifesti da completare in modo naturale',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/expand-scene-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/expand-scene-after.jpg',
    faq: [
      {
        question:
          'È utile anche se ho solo una foto molto tagliata o senza margini?',
        answer:
          'Sì, è ideale quando la persona nella foto è troppo vicina ai bordi o non c’è abbastanza spazio attorno per inserirla in una cornice, in un manifesto o in una composizione.',
      },
      {
        question:
          'Posso usarla per tagliare una parte della foto che non mi convince e ricostruirla?',
        answer:
          'Sì, è un ottimo uso della funzione. Se c’è un dettaglio nella foto che vuoi rimuovere — come una spalla coperta o un elemento che disturba — puoi tagliarlo con la funzione Ritaglia di Giotto e poi usare Espandi Scena per rigenerare in modo credibile quella porzione.',
      },
      {
        question: 'Posso scegliere io quanto espandere?',
        answer:
          'Sì, puoi decidere tu quali lati (destra, sinistra, sopra, sotto) e quanto spazio aggiungere prima di usare Espandi Scena.',
      },
    ],
  },
  'background-fusion': {
    title: 'Fusione Sfondo',
    highlightText: '🌅 Foto e sfondo diventano un’unica immagine',
    description:
      'Elimina l’effetto “foto ritagliata e incollata”: l’AI generativa fonde il ritratto del defunto con lo sfondo del manifesto, armonizzando luci, colori e dettagli come in un unico scatto.',
    whenToUse:
      'Manifesti dove la foto risulta staccata dallo sfondo • Ritratti da ambientare in cieli e sfondi commemorativi • Composizioni dove foto e sfondo devono risultare coerenti',
    costLabel: '1 credito',
    beforeImg: '/assets/sidebar/ai/before-after/fusione_sfondo_before.jpg',
    afterImg: '/assets/sidebar/ai/before-after/fusione_sfondo_after.jpg',
    landscapeImages: true,
    faq: [
      {
        question: 'Cosa serve prima di avviarla?',
        answer:
          'Uno sfondo applicato al manifesto e la foto del defunto selezionata sul foglio. Se lo sfondo manca, Giotto ti propone di sceglierne uno dalla libreria o di crearlo con l’IA.',
      },
      {
        question: 'Quanto tempo richiede?',
        answer:
          'In genere 1–2 minuti. L’avanzamento è visibile nella barra durante la generazione.',
      },
      {
        question: 'La foto originale viene persa?',
        answer:
          'No: il risultato viene salvato tra gli allegati del progetto e applicato come sfondo, mentre la foto originale resta disponibile tra gli allegati.',
      },
    ],
  },

  // Quality & Restoration features
  imageEnhancement: {
    title: 'Migliora Risoluzione',
    highlightText: '🖼️ Rendi le immagini più nitide e dettagliate',
    description:
      'Trasforma immagini sfocate o poco definite in versioni più nitide e dettagliate. L’AI analizza e ricostruisce ogni elemento per ottenere un risultato più leggibile, anche su formati più grandi.',
    whenToUse:
      'Immagini con dettagli poco chiari • Foto da stampare in grande formato • Ingrandimenti per manifesti e ricordini • File recuperati da WhatsApp o altri strumenti compressi',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/migliora-foto-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/migliora-foto-after.jpg',
    faq: [
      {
        question: 'È utile anche per foto da WhatsApp?',
        answer:
          'Sì, è ottima per rendere più nitide le immagini compresse o inviate tramite app di messaggistica.',
      },
    ],
  },
  colorizebw: {
    title: 'Colora Foto Bianco e Nero',
    highlightText: '🌈 Aggiungi colore ai ricordi',
    description:
      'L’AI analizza la foto in bianco e nero e applica tonalità realistiche, ridando vita all’immagine in pochi secondi. Ideale per manifesti, ricordini e qualsiasi stampa che richieda un tocco di colore in più.',
    whenToUse:
      'Ritratti d’epoca • Foto di famiglia in bianco e nero • Immagini storiche da valorizzare • Manifesti funebri più coinvolgenti',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/colorize-bw-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/colorize-bw-after.jpg',
    faq: [
      {
        question: 'I colori sono esatti al 100 %?',
        answer:
          'No: i colori vengono generati automaticamente dall’AI. Sono verosimili, ma potrebbero non rispecchiare fedelmente la realtà.',
      },
    ],
  },
  'restore-photo': {
    title: 'Restaura Foto',
    highlightText: '🔧 Recupera foto preziose danneggiate',
    description:
      "Ripara automaticamente foto rovinate dal tempo. Indispensabile quando le famiglie hanno solo foto danneggiate del loro caro. Rimuove graffi, macchie e pieghe preservando l'autenticità.",
    whenToUse:
      'Uniche foto disponibili danneggiate • Foto di famiglia deteriorate • Documenti storici per commemorazioni • Immagini con macchie o strappi • Foto sbiadite dal tempo',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/restaura-foto-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/restaura-foto-after.jpg',
    faq: [
      {
        question: 'Cosa riesce a sistemare il restauro?',
        answer:
          'Corregge graffi, linee marcate, pieghe, macchie e aree scolorite o sbiadite. È pensata per restituire un aspetto curato e continuo anche a immagini molto segnate dal tempo.',
      },
      {
        question: 'La foto mantiene l’aspetto originale?',
        answer:
          'Sì. Il restauro si concentra solo sui difetti visivi e non altera espressioni, lineamenti o l’atmosfera dello scatto. Il risultato finale resta fedele al ricordo originale.',
      },
      {
        question: 'Posso usarla per rendere la foto più nitida?',
        answer:
          'Non è questa la funzione pensata per migliorare la nitidezza. Il suo scopo è riparare danni visibili come graffi, pieghe o zone mancanti. A volte, come effetto collaterale, l’AI può rendere alcuni dettagli leggermente più definiti, ma non è garantito. Per migliorare davvero la nitidezza, ti consigliamo di usare Migliora Risoluzione.',
      },
    ],
  },
  'remove-document-photo-marks': {
    title: 'Ripulisci Foto Documento',
    highlightText: '📄 Rimuovi timbri e segni dai documenti',
    description:
      "Elimina timbri, marcature e annotazioni da foto tessera e documenti. Utile quando l'unica foto disponibile del defunto proviene da documenti ufficiali con timbri.",
    whenToUse:
      "Foto tessera da documenti per manifesti • Passaporti o carte d'identità con timbri • Foto militari o istituzionali marcate • Documenti storici per commemorazioni • Badge aziendali con sovrastampe",
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/ripulisci-foto-documento-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/ripulisci-foto-documento-after.jpg',
    faq: [
      {
        question: 'È utile quando la famiglia ha solo una foto su documento?',
        answer:
          'Sì, abbiamo pensato questa funzione proprio per aiutare le agenzie in situazioni in cui la famiglia non dispone di una foto migliore. Rimuove timbri e segni da documenti ufficiali, permettendo di ottenere un ritratto pulito e rispettoso, adatto alla stampa su manifesti e ricordini.',
      },
    ],
  },

  // Face & Beauty features
  makeLookYounger: {
    title: 'Filtro Bellezza',
    highlightText: '💫 Ritocco delicato e rispettoso',
    description:
      "Attenua con delicatezza i segni dell'età o della malattia. Permette di presentare il defunto nel suo aspetto migliore, come la famiglia desidera ricordarlo.",
    whenToUse:
      'Foto dopo lunga malattia • Ritratti per ricordini speciali • Immagini per cappelle ardenti digitali • Foto per manifesti commemorativi • Richieste specifiche delle famiglie',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/filtro-bellezza-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/filtro-bellezza-after.jpg',
    faq: [
      {
        question: 'In quali casi è opportuno usare il Filtro Bellezza?',
        answer:
          'Questa funzione è pensata per situazioni in cui la famiglia chiede espressamente di addolcire l’immagine del defunto, ad esempio dopo una lunga malattia. L’abbiamo sviluppata per supportare le agenzie funebri anche in queste richieste particolari. Il ritocco è lieve e rispettoso, ma può modificare leggermente l’aspetto: per questo ne consigliamo l’uso solo quando è realmente desiderato.',
      },
    ],
  },
  smile: {
    title: 'Sorriso',
    highlightText: '😊 Un ultimo ricordo sereno',
    description:
      "Aggiunge un'espressione serena e pacifica al volto. Particolarmente richiesto quando le uniche foto disponibili mostrano espressioni serie o sofferenti.",
    whenToUse:
      'Foto documenti con espressione seria • Ritratti per ricordini personalizzati • Richieste delle famiglie per ricordi positivi • Foto militari o istituzionali • Composizioni per cerimonie di commiato',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/smile-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/smile-after.jpg',
  },
  faceEnhancement: {
    title: 'Migliora Viso',
    highlightText: '👤 Definizione professionale del ritratto',
    description:
      'Rende il volto più nitido e definito quando la foto è sgranata o poco chiara, grazie a un sistema intelligente di ricostruzione. È utile per valorizzare ritratti poco leggibili, preservando l’identità della persona e migliorando la resa su manifesti, ricordini e stampe di grande formato.',
    whenToUse:
      'Foto sfocate o di bassa qualità • Ritratti per manifesti di grande formato • Immagini per libri firma • Foto per proiezioni durante le cerimonie • Ritratti per siti commemorativi online',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/migliora-viso-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/migliora-viso-after.jpg',
    faq: [
      {
        question: 'In quali casi è opportuno usare Migliora Viso?',
        answer:
          'Questa funzione è pensata per situazioni in cui la foto disponibile è poco nitida o sgranata, ma la famiglia desidera comunque un ritratto ben leggibile e adatto alla stampa. L’abbiamo sviluppata per aiutare le agenzie a valorizzare al meglio anche le immagini di qualità non ottimale, migliorando la definizione del volto senza alterarne i tratti.',
      },
      {
        question:
          'Che differenza c’è tra Migliora Viso e Migliora Risoluzione?',
        answer:
          'Le due funzioni sono simili, ma con obiettivi diversi. Migliora Viso si concentra esclusivamente sul volto, rendendolo più nitido e definito. Migliora Risoluzione invece agisce su tutta la foto, migliorando anche abiti, sfondo e altri dettagli. Se ti interessa solo il volto, scegli Migliora Viso. Se vuoi valorizzare l’intera immagine, usa Migliora Risoluzione.',
      },
    ],
  },
  'remove-glasses': {
    title: 'Rimuovi Occhiali',
    highlightText: '👓 Mostra il volto senza occhiali',
    description:
      "Rimuove gli occhiali quando richiesto dalle famiglie per mostrare il volto completo del defunto. L'AI ricostruisce naturalmente la zona degli occhi.",
    whenToUse:
      'Richieste specifiche delle famiglie • Foto per ricordini religiosi • Ritratti per manifesti dove si preferisce il volto scoperto • Foto tessera con occhiali • Composizioni commemorative speciali',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-glasses-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-glasses-after.jpg',

    faq: [
      {
        question: 'In quali casi è opportuno usare Rimuovi Occhiali?',
        answer:
          'Abbiamo creato questa funzione per supportare le agenzie quando la famiglia chiede espressamente di mostrare il volto del defunto senza occhiali. L’AI ricostruisce in modo naturale la zona degli occhi, così da ottenere un ritratto più vicino al ricordo che i familiari desiderano conservare.',
      },
    ],
  },
  'remove-glasses-glare': {
    title: 'Rimuovi Riflesso Occhiali',
    highlightText: '✨ Elimina riflessi per vedere gli occhi',
    description:
      'Rimuove i riflessi fastidiosi dalle lenti preservando gli occhiali. Permette di vedere chiaramente gli occhi del defunto, elemento importante per molte famiglie.',
    whenToUse:
      'Foto con flash che nascondono gli occhi • Ritratti per manifesti e ricordini • Foto tessera con riflessi • Immagini per cappelle ardenti digitali • Richieste di famiglie per vedere gli occhi',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-glare-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-glare-after.jpg',
    faq: [
      {
        question: 'Cosa fa esattamente Rimuovi Riflesso Occhiali?',
        answer:
          'Elimina i riflessi dalle lenti, rendendo visibili gli occhi anche in foto scattate con flash o luce diretta. Se gli occhi non sono per nulla visibili, la funzione prova a ricostruirli in modo credibile in base al volto, ma il risultato può variare in base alla qualità della foto.',
      },
    ],
  },

  // Corrections & Removals features
  'magic-eraser': {
    title: 'Pennello Correttivo',
    highlightText: '🪄 Rimuovi elementi di disturbo',
    description:
      "Elimina persone o oggetti indesiderati dalle foto. Utile per isolare il defunto in foto di gruppo o rimuovere elementi che distraggono dall'immagine commemorativa.",
    whenToUse:
      'Isolare il defunto da foto di gruppo • Rimuovere persone estranee • Eliminare oggetti di disturbo • Pulire sfondi per manifesti • Preparare ritratti per ricordini',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/pennello-correttivo-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/pennello-correttivo-after.jpg',
  },
  'change-clothes': {
    title: 'Cambia Abito',
    highlightText: '👔 Vesti il defunto come desiderato',
    description:
      "Modifica l'abbigliamento nelle foto quando richiesto dalle famiglie. Permette di presentare il defunto con abiti formali, uniformi o abbigliamento preferito.",
    whenToUse:
      'Aggiungere abiti formali per manifesti • Ricreare uniformi militari o professionali • Sostituire abiti ospedalieri • Rispettare richieste specifiche delle famiglie • Adattare abbigliamento per contesti religiosi',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/change-clothes-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/change-clothes-after.jpg',
  },
  'remove-hug': {
    title: 'Rimuovi Abbraccio',
    highlightText: '🤝 Isola il defunto con rispetto',
    description:
      "Separa delicatamente il defunto da abbracci o contatti fisici in foto di gruppo. L'AI ricostruisce le parti nascoste per creare un ritratto individuale dignitoso.",
    whenToUse:
      'Creare ritratti singoli da foto di coppia • Isolare il defunto per manifesti • Separare da foto familiari quando richiesto • Preparare immagini per ricordini individuali • Rispondere a richieste specifiche delle famiglie',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-hug-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/remove-hug-after.jpg',
  },
  'remove-the-person-in-front-of-the-subject': {
    title: 'Rimuovi Persona Davanti',
    highlightText: '🚶 Recupera ritratti ostruiti',
    description:
      "Rimuove persone che coprono parzialmente il defunto in foto di gruppo o eventi. Permette di recuperare l'unica foto disponibile quando il soggetto è parzialmente nascosto.",
    whenToUse:
      'Foto di eventi con persone davanti • Immagini di cerimonie affollate • Recupero di foto dove il defunto è parzialmente coperto • Foto di gruppo con sovrapposizioni • Unica foto disponibile con ostruzioni',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/rimuovi-persona-davanti-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/rimuovi-persona-davanti-after.jpg',
    faq: [
      {
        question: 'Funziona se il defunto è molto coperto?',
        answer:
          "Il defunto deve essere visibile almeno al 50-60%. L'AI ricostruisce le parti mancanti basandosi su ciò che è visibile.",
      },
    ],
  },
  'remove-the-object-in-front-of-the-subject': {
    title: 'Rimuovi Oggetti Davanti',
    highlightText: '🧹 Recupera ritratti coperti da oggetti',
    description:
      "Rimuove oggetti che coprono o disturbano il soggetto principale, ricostruendo in modo naturale le parti nascoste senza alterare il volto o l'identità del defunto.",
    whenToUse:
      'Oggetti davanti al volto o al corpo • Foto con fiori, sedie o arredi che coprono il soggetto • Immagini di cerimonie con elementi in primo piano • Recupero di foto parzialmente ostruite • Unica foto disponibile con oggetti di disturbo',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/rimuovi-oggetti-davanti-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/rimuovi-oggetti-davanti-after.jpg',
    faq: [
      {
        question: 'Funziona se gli oggetti coprono molto il defunto?',
        answer:
          "Il soggetto deve restare almeno parzialmente visibile. L'AI ricostruisce le parti coperte basandosi sugli elementi presenti nella foto, quindi il risultato varia in base a qualità e quantità di dettaglio disponibile.",
      },
    ],
  },
  'correct-posture': {
    title: 'Correggi Postura',
    highlightText: '🧍 Allinea il volto in modo naturale',
    description:
      "Raddrizza delicatamente la postura della testa quando il soggetto appare inclinato verso un'altra persona o non allineato con collo, spalle e corpo. Mantiene identità, espressione, capelli, abiti, luce e sfondo originali.",
    whenToUse:
      'Ritratti dove la testa è inclinata • Foto di coppia da trasformare in ritratto singolo • Immagini dove il soggetto sembra appoggiato a qualcuno • Manifesti e ricordini che richiedono una posa più composta • Recupero di foto con postura non naturale',
    cost: 1,
    beforeImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/correggi-postura-before.jpg',
    afterImg:
      'https://cdn.onoranzefunebricloud.com/giotto/ai/before-after/correggi-postura-after.jpg',
    faq: [
      {
        question: 'La funzione cambia il volto o l’espressione?',
        answer:
          'No, la correzione è pensata per modificare solo la postura della testa. Lineamenti, espressione e identità devono restare il più possibile invariati.',
      },
      {
        question: 'Quando funziona meglio?',
        answer:
          'Funziona meglio quando volto, collo e spalle sono visibili almeno in parte. Se molte aree sono coperte o tagliate, la ricostruzione può variare in base ai dettagli disponibili.',
      },
    ],
  },
};

/**
 * Initialize AI Feature Help Modal
 */
export function initAiFeatureHelp() {
  // Remove any existing listeners to prevent duplicates
  $('body').off('click.aihelp', '.ai-help-btn');

  // Use a namespaced event handler with capturing phase
  $(document).on('click.aihelp', '.ai-help-btn', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent triggering the parent AI feature click
    e.stopImmediatePropagation(); // Ensure no other handlers are called

    const featureId = $(this).data('ai-feature');
    const helpContent = AI_FEATURE_HELP_CONTENT[featureId];

    if (!helpContent) {
      console.warn(`Help content not found for feature: ${featureId}`);
      return false;
    }

    // Populate modal content
    $('#aiFeatureHelpTitle').text(helpContent.title);
    $('#aiFeatureDescription').text(helpContent.description);
    $('#aiFeatureWhenToUse').text(helpContent.whenToUse);

    // Show cost if available
    if (helpContent.cost || helpContent.costLabel) {
      $('#aiFeatureCost').show();
      $('#aiFeatureCostValue').text(
        helpContent.costLabel ||
          `${helpContent.cost} credito${helpContent.cost > 1 ? 'i' : ''}`
      );
    } else {
      $('#aiFeatureCost').hide();
    }

    // Show before/after images if available
    if (helpContent.beforeImg) {
      $('#aiFeatureBeforeImg').attr('src', helpContent.beforeImg).show();
    } else {
      $('#aiFeatureBeforeImg').hide();
    }

    if (helpContent.afterImg) {
      $('#aiFeatureAfterImg').attr('src', helpContent.afterImg).show();
    } else {
      $('#aiFeatureAfterImg').hide();
    }

    // Show modal
    $('#aiFeatureHelpModal').modal('show');

    return false; // Prevent any further event processing
  });
}
